import React from "react";

const Text = (props) => {
  const { label, placeholder, onChange = () => {}, isRequired, type, value } = props;
  return (
    <>
      {label && (
        <label className="mmmbaa_label">
          {label}
          {isRequired ? <span className="required_star">*</span> : ""}
        </label>
      )}
      <input className="input_text" type={type} placeholder={`${placeholder}`} value={value} onChange={(e) => onChange(e.target.value)} />
    </>
  );
};

export default Text;
